// extracted by mini-css-extract-plugin
export default {"label":"CurrencyLabelComponent_label__raTqR","disabled":"CurrencyLabelComponent_disabled__SxwhY"};